module.exports = __webpack_public_path__ + "img/dropdown2.5527e0fe.svg";